import { create } from 'zustand';
import { Code } from '../types/api/autSetCodList';

export interface CodeState {
    codes: Record<string, Code[]>;
    setCodes: (codes: Record<string, Code[]>) => void;
    getCode: (category: string, code: string) => string | undefined;
    getCodes: (category: string) => Code[];
}

export const useCodeStore = create<CodeState>((set, get) => ({
    codes: {},
    setCodes: (newCodes) =>
        set((state) => ({
            codes: { ...state.codes, ...newCodes },
        })),
    getCode: (category, code) => {
        return get().codes[category]?.find((item) => item.code === code)?.name;
    },
    getCodes: (category) => {
        return get().codes[category] ?? [];
    },
}));
